export const ADD_USER = "ADD_USER";
export const ADD_USER_ERROR = "ADD_USER_ERROR";

export const REMOVE_USER = "REMOVE_USER";
export const REMOVE_USER_ERROR = "REMOVE_USER_ERROR";

export const AUTHORIZATION = "AUTHORIZATION";